import React, { createContext, useContext, useEffect, useState } from 'react';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import getLocal from '@/app/utils/getLocal';

export interface MemberTimeItem {
    summerTimezone: string;
    winterTimezone: string;
    commonTimezone: string;
    switchSummerTimestamp: number;
    switchWinterTimestamp: number;
    enable: boolean;
    id: string;
    needSwitchFlag: boolean;
    site: string;
    year: number;
}

const initState: MemberTimeItem[] = [];

export interface EcoAction {
    type: string;
    payload: any;
}

export const MemberTimeContext = createContext<{ state: { timezoneList: MemberTimeItem[] } }>({ state: { timezoneList: initState } });

export const MemberTimeProvider = ({ children }: { children: React.ReactNode }) => {
    const [seasonInfo, setSeasonInfo] = useState<MemberTimeItem[]>(initState);
    const { locale } = getLocal();

    const SouthernCountrys = ['au'];

    const replaceTimeFormat = (timeStr: string) => {
        if (!timeStr) return '';
        return timeStr.replaceAll('-', '/');
    };

    //     getCurrentBeiJingTime();
    //     const res = await getWebsiteTimezoneConfig(locale, {});

    //     if (res.code === '0' && res.data) {
    //         if (res.data?.length > 0) {
    //             const timezoneList =
    //                 res.data.map((item: any) => {
    //                     const summerTimestamp = item.switchSummerTime ? new Date(`${replaceTimeFormat(item.switchSummerTime)} GMT+8`).getTime() : 0;
    //                     const winterTimestamp = item.switchWinterTime ? new Date(`${replaceTimeFormat(item.switchWinterTime)} GMT+8`).getTime() : 0;
    //                     return {
    //                         summerTimezone: item.summerTimezone,
    //                         winterTimezone: item.winterTimezone,
    //                         commonTimezone: item.commonTimezone,
    //                         switchSummerTimestamp: summerTimestamp,
    //                         switchWinterTimestamp: winterTimestamp,
    //                         enable: item.enable,
    //                         id: item.id,
    //                         needSwitchFlag: item.needSwitchFlag,
    //                         site: item.site,
    //                         year: item.year,
    //                     };
    //                 }) || [];
    //             setSeasonInfo(timezoneList);
    //         }
    //     }
    // };

    useEffect(() => {
        editorEventsBus.on('member-global-a', (data: any) => {
            setSeasonInfo(data);
        });
    }, []);

    return (
        <MemberTimeContext.Provider
            value={{
                state: {
                    timezoneList: seasonInfo,
                },
            }}
        >
            {children}
        </MemberTimeContext.Provider>
    );
};

export const useMemberTimeStore = () => {
    const store = useContext(MemberTimeContext);

    return store.state;
};
